export const INTERNAL_VOCAL_ROUTINE_FOUNDER_USER_ID =
  (process.env.REACT_APP_INTERNAL_VOCAL_ROUTINE_USER_ID || '').trim();

export function isInternalVocalRoutineFounder(user) {
  return Boolean(
    INTERNAL_VOCAL_ROUTINE_FOUNDER_USER_ID &&
    user?.role === 'admin' &&
    String(user?._id || '') === INTERNAL_VOCAL_ROUTINE_FOUNDER_USER_ID
  );
}
